module.exports = __webpack_public_path__ + "f39a15fb83cfaf47d76e4b450da72332.jpg";